import { useState } from "react";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  InputGroup,
  Card,
  Stack,
  Table,
} from "react-bootstrap";
import { FaTrash, FaXmark } from "react-icons/fa6";
import { FiPlusSquare } from "react-icons/fi";

const UpdateOrder = ({ setUpdateNewProduct }) => {
  const [items, setItems] = useState([
    {
      id: Date.now(),
      name: "New Product",
      sku: "16",
      qty: 1,
      price: 10,
      image:
        "https://rukminim2.flixcart.com/image/612/612/xif0q/lipstick/a/1/7/-original-imahjru97xuzmryz.jpeg",
      url: "http://localhost:3000/home",
    },
  ]);

  const [discount, setDiscount] = useState(100);
  const [couponDiscount, setCouponDiscount] = useState(50);
  const tax = 50;

  const addItem = () => {
    setItems([
      ...items,
      {
        id: Date.now(),
        name: "",
        sku: "",
        qty: 1,
        price: 20,
        image: "https://rukminim2.flixcart.com/image/612/612/xif0q/lipstick/a/1/7/-original-imahjru97xuzmryz.jpeg",
        url: "http://localhost:3000/home",
      },
    ]);
  };

  const removeItem = (id) => {
    setItems(items.filter((item) => item.id !== id));
  };

  const updateItem = (id, field, value) => {
    setItems(
      items.map((item) =>
        item.id === id ? { ...item, [field]: value } : item,
      ),
    );
  };

  const subtotal = items.reduce((sum, item) => sum + item.qty * item.price, 0);
  const total = subtotal - discount - couponDiscount + tax;

  return (
    <>
      <div className="h-100 d-flex flex-column w-100">
        {/* Header */}
        <div className="bg-white border-bottom py-2 px-3">
          <div className="hstack justify-content-between">
            <h6 className="fw-semibold m-0">Update New Order</h6>
            <button
              className="icon-btn danger"
              title="Close"
              onClick={() => setUpdateNewProduct("")}
            >
              <FaXmark />
            </button>
          </div>
        </div>

        {/* Order Meta */}
        <div className="bg-white border-bottom py-2 px-3">
          <div className="hstack justify-content-between">
            <div style={{ lineHeight: 1 }}>
              <h6 className="fw-semibold m-0">Order Id: #12521</h6>
              <Form.Text style={{ fontSize: 10 }}>
                Payment Date | Time : 26 Jan 2026 | 12:54:56
              </Form.Text>
            </div>
            <InputGroup className="w-auto">
              <Form.Select style={{ width: 150 }}>
                <option value="">Hold</option>
                <option value="processing">Processing</option>
                <option value="completed">Completed</option>
              </Form.Select>
              <Button title="Save" style={{ fontSize: 12 }}>
                Save
              </Button>
            </InputGroup>
          </div>
        </div>

        {/* Content */}
        <div className="flex-grow-1 overflow-auto">
          <Container
            fluid
            className="border-end overflow-auto py-2"
            style={{ height: "calc(100vh - 157px)" }}
          >
            <Row className="g-2">
              <Form.Group as={Col} md={12}>
                <Card>
                  <Card.Body>
                    <Row>
                      {/* General */}
                      <Col md={4} className="mb-2 border-end">
                        <Card.Text className="fw-semibold">General</Card.Text>

                        <Form.Group className="mb-1">
                          <Form.Label>Created At</Form.Label>
                          <Form.Control type="datetime-local" />
                        </Form.Group>
 
                        <Form.Group className="mb-1">
                          <Form.Label>Customer</Form.Label>
                          <Form.Select>
                            <option value="1">Roop Chandra</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      {/* Billing */}
                      <Col md={4} className="mb-2 border-end">
                        <Card.Text className="fw-semibold">
                          Billing Details
                        </Card.Text>

                        <Stack gap={1} style={{ fontSize: 13 }}>
                          <div>
                            <strong>Name:</strong> Roop Chandra
                          </div>
                          <div>
                            <strong>Email:</strong> roop@gmail.com
                          </div>
                          <div>
                            <strong>Phone:</strong> +91 98765 43210
                          </div>
                          <div>
                            <strong>Address:</strong> 221B Baker Street
                          </div>
                          <div>
                            <strong>City:</strong> New Delhi
                          </div>
                          <div>
                            <strong>State:</strong> Delhi
                          </div>
                          <div>
                            <strong>Pincode:</strong> 110001
                          </div>
                          <div>
                            <strong>Country:</strong> India
                          </div>
                        </Stack>
                      </Col>

                      {/* Shipping */}
                      <Col md={4} className="mb-2">
                        <Card.Text className="fw-semibold">
                          Shipping Details
                        </Card.Text>

                        <Stack gap={1} style={{ fontSize: 13 }}>
                          <div>
                            <strong>Name:</strong> Roop Chandra
                          </div>
                          <div>
                            <strong>Phone:</strong> +91 98765 43210
                          </div>
                          <div>
                            <strong>Address:</strong> 45 MG Road
                          </div>
                          <div>
                            <strong>City:</strong> Gurugram
                          </div>
                          <div>
                            <strong>State:</strong> Haryana
                          </div>
                          <div>
                            <strong>Pincode:</strong> 122001
                          </div>
                          <div>
                            <strong>Country:</strong> India
                          </div>
                        </Stack>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Form.Group>
              <Form.Group as={Col} md={12}>
                <Card>
                  <Card.Body>
                    <div className="hstack justify-content-between gap-2 mb-2">
                      <div className="hstack gap-2">
                        <h6 className="fw-semibold m-0">Invoice Items</h6>
                        <FiPlusSquare
                          className="CP"
                          title="Add Item"
                          size={20}
                          onClick={addItem}
                        />
                      </div>
                      <div className="hstack gap-2">
                        <Button size="sm">Add Coupon</Button>
                        <Button size="sm">Add Discount</Button>
                      </div>
                    </div>

                    <Table
                      hover
                      className="contacts-table mb-0"
                      style={{ verticalAlign: "middle" }}
                    >
                      <thead>
                        <tr>
                          <th>Item</th>
                          <th>SKU</th>
                          <th width="120">Qty</th>
                          <th width="120">Price</th>
                          <th width="120">Total</th>
                          <th width="50"></th>
                        </tr>
                      </thead>

                      <tbody>
                        {items.map((item) => (
                          <tr key={item.id}>
                            <td>
                              <div className="d-flex gap-2">
                                  <img
                                    src={item.image}
                                    width={30}
                                    height={30}
                                    alt=""
                                  />
                                <div>
                                  <div className="fw-medium">New Product</div>
                                  <small className="text-muted">
                                    {item.url}
                                  </small>
                                </div>
                              </div>
                            </td>

                            <td>16</td>
                            <td>
                              <Form.Control
                                type="number"
                                size="sm"
                                value={item.qty}
                                min={1}
                                onChange={(e) =>
                                  updateItem(
                                    item.id,
                                    "qty",
                                    Number(e.target.value),
                                  )
                                }
                              />
                            </td>
                            <td>{item.price}</td>

                            <td className="fw-semibold">
                              ${item.qty * item.price}
                            </td>

                            <td className="text-center">
                              <FaTrash
                                className="text-danger CP"
                                onClick={() => removeItem(item.id)}
                              />
                            </td>
                          </tr>
                        ))}

                        {/* Invoice Summary */}
                        <tr className="border-bottom-0">
                          <td colSpan={4} className="text-end">
                            Subtotal
                          </td>
                          <td colSpan={2} className="fw-semibold">
                            ${subtotal}
                          </td>
                        </tr>

                        <tr className="border-bottom-0">
                          <td colSpan={4} className="text-end">
                            Discount
                          </td>
                          <td colSpan={2} className="text-danger">
                            -${discount}
                          </td>
                        </tr>

                        <tr className="border-bottom-0">
                          <td colSpan={4} className="text-end">
                            Coupon Discount
                          </td>
                          <td colSpan={2} className="text-danger">
                            -${couponDiscount}
                          </td>
                        </tr>

                        <tr className="border-bottom-0">
                          <td colSpan={4} className="text-end">
                            Tax
                          </td>
                          <td colSpan={2} className="text-success">
                            +${tax}
                          </td>
                        </tr>

                        <tr className="table-light">
                          <td colSpan={4} className="text-end fw-bold">
                            Grand Total
                          </td>
                          <td colSpan={2} className="fw-bold text-success fs-6">
                            ${total}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Card.Body>
                </Card>
              </Form.Group>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};

export default UpdateOrder;
